import { ChevronDownIcon } from '@chakra-ui/icons';
import { VStack, HStack, Box, useMediaQuery, useDisclosure } from '@chakra-ui/react';
import { Button } from 'Atoms';
import { Breadcrumbs } from 'Molecules/Breadcrumbs';
import { StandardSwitcher } from '../ReportComponents/StandardSwitcher';
import { Menu } from 'Molecules/Menu';
import { EsrsReportStandardSwitch } from '../Report.types';
import { Loader } from 'Molecules';
import { JSX } from 'react';

type ReportContainerProps = {
  reportDocGenerator: JSX.Element;
  canDownloadEsrsReport: boolean;
  standards: EsrsReportStandardSwitch[];
  structureLoading: boolean;
  loading: boolean;
  sideMenu: React.ReactNode;
  reportContent: React.ReactNode;
  standardIndex: number;
  setStandardIndex: (index: number) => void;
};

const ReportContainer = ({
  reportDocGenerator,
  canDownloadEsrsReport,
  standards,
  structureLoading,
  loading,
  sideMenu,
  reportContent,
  standardIndex,
  setStandardIndex,
}: ReportContainerProps) => {
  const [isSmall] = useMediaQuery('(max-width: 1600px)');
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <VStack w="100%" gap="0px" position="relative" overflow="hidden">
      <HStack
        w="100%"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="border.decorative"
        p="12px 16px"
        position="sticky"
        top="0"
        bg="bg.default"
        zIndex={2}
      >
        <Box w="30%">
          <Breadcrumbs noPadding />
        </Box>
        <StandardSwitcher
          standardIndex={standardIndex}
          isLoading={structureLoading}
          setStandardIndex={setStandardIndex}
          standards={standards}
        />
        <HStack w="30%" justifyContent="flex-end">
          <Menu
            size="lg"
            isOpen={isOpen}
            onClose={onClose}
            onOpen={onOpen}
            menuButton={
              <Button rightIcon={<ChevronDownIcon color="inherit" />} variant="primary">
                Download
              </Button>
            }
            sections={[
              {
                actions: [
                  {
                    id: 'esrs-report-word-doc',
                    render: () => (isOpen ? reportDocGenerator : <></>),
                    isDisabled: !canDownloadEsrsReport,
                    tooltipText: canDownloadEsrsReport ? '' : 'Contact us to enable this feature',
                  },
                ],
              },
            ]}
          />
        </HStack>
      </HStack>
      <HStack
        alignItems="start"
        justifyContent={isSmall ? 'flex-start' : 'center'}
        w="100%"
        paddingInline="16px"
        overflow="hidden"
        overflowX="auto"
      >
        {sideMenu}
        {loading ? <Loader /> : reportContent}
        <Box minW="200px" h="100%"></Box>
      </HStack>
    </VStack>
  );
};

export default ReportContainer;
